import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DwConfigService, DwConfigServiceToken, SuppressErrorMessagesHeader } from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { ScenarioImageResult } from '../models/scenario-image.model';

@Injectable({ providedIn: 'root' })
export class ScenarioImageService {
  private readonly api: string;

  constructor(private readonly http: HttpClient, @Inject(DwConfigServiceToken) config: DwConfigService) {
    this.api = `${config.coreConfig.apiRoot}/aviator-online/ai/scenario-images`;
  }

  generate(prompt: string): Observable<ScenarioImageResult> {
    return this.http.post<ScenarioImageResult>(this.api, { prompt }, {
      headers: { [SuppressErrorMessagesHeader]: 'true' },
    });
  }
}
